<ion-header>
    <app-header [middleIcon]="false"
                [headerTitle]="task?.title"></app-header>
</ion-header>
<ion-content [fullscreen]="true">
    <div class="quiz-wrap page-width-and-shadow">
        <ion-skeleton-text *ngIf="!url" style="width:100%;height:2.5rem;margin-bottom: 1rem;" animated></ion-skeleton-text>
        <ion-skeleton-text *ngIf="!url" style="width:60%;height:2.5rem;margin-bottom: 1rem;" animated></ion-skeleton-text>
        <ion-skeleton-text *ngIf="!url" style="width:75%;height:2.5rem;margin-bottom: 1rem;" animated></ion-skeleton-text>

        <iframe *ngIf="!!url" [src]="url | safeUrl" frameborder="0" marginwidth="0" marginheight="0" allow=“encrypted-media” allowfullscreen webkitallowfullscreen mozallowfullscreen msallowfullscreen credentialless> </iframe>
    </div>
</ion-content>
